// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34d25c1e","944":"658532af"}[chunkId] + ".chunk.js";
};